import React from 'react';
import {connect} from 'react-redux';
import GroupDetails from './GroupDetails';
import {createGroup, deleteGroup, editGroup} from '../../store/actions/groupActions';
import {Link, withRouter} from 'react-router-dom';
import Grid from '@material-ui/core/Grid/Grid';
import {sectionStyles} from '../../styles/sectionStyles';
import {withStyles} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import ThumbDown from '@material-ui/icons/ThumbDown';
import ThumbUp from '@material-ui/icons/ThumbUp';
import ExitToApp from '@material-ui/icons/ExitToApp';
import Fab from '@material-ui/core/Fab/Fab';
import Header from '../layout/Header';
import {isCommaSeparatedField} from "../../utils/validationUtils";

class GroupForm extends React.Component {

  state = {
    id: this.props.group && this.props.group.id ? this.props.group.id: null,
    name: this.props.group && this.props.group.name ? this.props.group.name: '',
    file: this.props.group && this.props.group.file ? this.props.group.file: null,
    guests: this.props.group && this.props.group.guests ? this.props.group.guests: '',
    isOwnerUser: this.props.group && this.props.group.isOwnerUser,
    isPendingUser: this.props.group && this.props.group.isPendingUser,
    error: null,
  };

  handleOnChangeFile = (url) => {
    this.setState({file: url});
  };

  handleOnCreateGroup = (e) => {
    e.preventDefault();
    const isValidState = this.isValidStateToSave();
    if (!isValidState) {
      return;
    }
    if (!isCommaSeparatedField(this.state['guests'])) {
      this.setState({
        error: {
          guests: true
        }
      });
      return;
    }
    this.setState({
      error: {
        guests: false
      }
    }, () => {
      const paramsToAdd = this.getStateFilteredToAdd();
      const redirect = () => this.props.history.push('/groups');
      this.props.createGroup({group: paramsToAdd, redirect});
    });
  };

  handleOnEditGroup = (e) => {
    e.preventDefault();
    const isValidState = this.isValidStateToSave();
    if (!isValidState) {
      return;
    }
    if (!isCommaSeparatedField(this.state['guests'])) {
      this.setState({
        error: {
          guests: true
        }
      });
      return;
    }
    this.setState({
      error: {
        guests: false
      }
    }, () => {
      const paramsToEdit = this.getStateFilteredToEdit();
      const redirect = () => this.props.history.push('/groups');
      this.props.editGroup({group: paramsToEdit, redirect});
    });
  };

  isValidStateToSave () {
    const params = ['name', 'file', 'guests'];
    return params.every(param => this.state[param] !== '');
  };

  getStateFilteredToAdd() {
    const params = ['name', 'file', 'guests'];
    return this.getFilteredParams({params});
  };

  getStateFilteredToEdit() {
    const params = ['id', 'name', 'file', 'guests'];
    return this.getFilteredParams({params});
  };

  getFilteredParams({params}) {
    return params.reduce((prev, next) => {
      return {
        ...prev,
        [next]: this.state[next]
      }
    }, {})
  };

  handleOnDeleteGroup = (e) => {
    e.preventDefault();
    const redirect = () => this.props.history.push('/groups');
    this.props.deleteGroup({id: this.state.id, redirect});
  };

  handleOnChangeInput = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  handleOnSetInputValue = (id, value) => {
    this.setState({
      [id]: value
    });
  };

  handleGroupPermanency = (action) => {
    const paramsToEdit = {
      id: this.state.id,
      invitationAction: action,
    }
    const redirect = () => this.props.history.push('/groups');
    this.props.editGroup({group: paramsToEdit, redirect});
  };

  getInfoToRender() {
    const { group } = this.props;
    const { isOwnerUser, isPendingUser } = this.state;
    if (group) {
      const deleteButton = isOwnerUser ? <Fab color={`primary`} aria-label="add" size={`small`} onClick={this.handleOnDeleteGroup}><DeleteIcon /></Fab> : null;
      const saveButton = isOwnerUser ? <Fab color={`primary`} aria-label="save" size={`small`} onClick={this.handleOnEditGroup}><SaveIcon /></Fab> : null;
      const declineGroupButton = isPendingUser ? <Fab color={`primary`} aria-label="save" size={`small`} onClick={e => {
        e.preventDefault();
        this.handleGroupPermanency('R');
      }}><ThumbDown /></Fab> : null;
      const acceptGroupButton = isPendingUser ? <Fab color={`primary`} aria-label="save" size={`small`} onClick={e => {
        e.preventDefault();
        this.handleGroupPermanency('A');
      }}><ThumbUp /></Fab> : null;
      const leaveGroupButton = !isOwnerUser && !isPendingUser ? <Fab color={`primary`} aria-label="save" size={`small`} onClick={e => {
        e.preventDefault();
        this.handleGroupPermanency('R');
      }}><ExitToApp /></Fab> : null;
      return {
        title: 'Editar Grupo',
        component: <GroupDetails id={this.state.id} name={this.state.name} admin={this.state.admin} guests={this.state.guests} file={this.state.file} isOwnerUser={this.state.isOwnerUser} isPendingUser={this.state.isPendingUser} handleOnChangeInput={this.handleOnChangeInput} handleOnSetInputValue={this.handleOnSetInputValue} handleOnChangeFile={this.handleOnChangeFile} handleOnEditGroupInside={this.handleOnEditGroupInside} error={this.state.error} />,
        buttons: [
          ...(declineGroupButton ? [declineGroupButton]: []),
          ...(acceptGroupButton ? [acceptGroupButton]: []),
          ...(leaveGroupButton ? [leaveGroupButton]: []),
          ...(deleteButton ? [deleteButton]: []),
          <Fab color={`primary`} aria-label="cancel" size={`small`} component={Link} to={`/groups`}><CloseIcon /></Fab>,
          ...(saveButton ? [saveButton]: []),
        ]
      }
    }
    return {
      title: 'Crear Grupo',
      component: <GroupDetails name={this.state.name} admin={this.state.admin} guests={this.state.guests} file={this.state.file} isOwnerUser={true} handleOnChangeInput={this.handleOnChangeInput} handleOnSetInputValue={this.handleOnSetInputValue} handleOnChangeFile={this.handleOnChangeFile} error={this.state.error}/>,
      buttons: [
        <Fab color={`primary`} aria-label="add" component={Link} to={`/groups`} size={`small`}><CloseIcon /></Fab>,
        <Fab color={`primary`} aria-label="add" size={`small`} onClick={this.handleOnCreateGroup}><SaveIcon /></Fab>
      ]
    }
  };

  render() {
    const {classes} = this.props;
    const {title, component, buttons} = this.getInfoToRender();
    return (
        <div className={classes.wrapperSection}>
          <Header title={title} />
          <div className={classes.wrapperSectionContent}>
            <div className={classes.appBarSpacer} />
            <Grid container className={classes.sectionContent}>
              <Grid item xs={12}>
                {component}
              </Grid>
            </Grid>
            <div className={classes.appBarSpacer} />
            <div className={classes.appBarSpacer} />
          </div>
          <div className={classes.navbarSection}>
            {buttons && buttons.map((button, index) => {
              return (
                <span key={index}>
                  {button}
                </span>
              )
            })}
          </div>
        </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createGroup: ({group, redirect}) => dispatch(createGroup({group, redirect})),
    editGroup: ({group, redirect}) => dispatch(editGroup({group, redirect})),
    deleteGroup: ({id, redirect}) => dispatch(deleteGroup({id, redirect}))
  }
};

export default withRouter(connect(null, mapDispatchToProps)(withStyles(sectionStyles)(GroupForm)));